module.exports = __webpack_public_path__ + "img/icon-btn-apk2.68e83dca.png";